import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import CurveLine from './curve-line.vue';
let default_1 = class default_1 extends Vue {
    // @Prop() readonly numData!: IUMC;
    daySummary;
    get speed() {
        const res = this.daySummary[0]?.averagePassSpeedHistoryList ?? [];
        // console.log("res:", this.daySummary)
        return res;
    }
    get averSpeed() {
        return (this.daySummary[0]?.averagePassSpeed || 0).toFixed(2);
    }
    mounted() { }
};
__decorate([
    Prop()
], default_1.prototype, "daySummary", void 0);
default_1 = __decorate([
    Component({
        name: 'ChartSpeed',
        components: { 'curve-line': CurveLine },
        i18n: {
            messages: {
                'en-us': {
                    averageSpeed: 'Average Velocity (Today)',
                    min: 'ppl/min',
                },
                zh: {
                    averageSpeed: '平均通行速度(今日)',
                    min: '人/分'
                },
            },
        }
    })
], default_1);
export default default_1;
